export default __webpack_public_path__ + "static/media/right-black-arrow-3.1e8fbe3d.png";